module.exports = __webpack_public_path__ + "img/lpnu_logo.d6ec0a1f.jpg";